export default "__VITE_ASSET__Dmy4PMRt__"